const compareNumbersAscending = (a, b) => a - b;

const quantileSorted = (sortedValues, probability) => {
  const count = sortedValues.length;

  if (count === 0) return undefined;
  if (probability <= 0 || count < 2) return sortedValues[0];
  if (probability >= 1) return sortedValues[count - 1];

  const index = (count - 1) * probability;
  const lowerIndex = Math.floor(index);
  const upperIndex = Math.ceil(index);
  const weight = index - lowerIndex;

  return sortedValues[lowerIndex] * (1 - weight) + sortedValues[upperIndex] * weight;
};

export const computeFiveNumberSummary = (values) => {
  if (!Array.isArray(values) || values.length === 0) return null;

  const sortedValues = [...values].sort(compareNumbersAscending);

  return {
    min: sortedValues[0],
    q1: quantileSorted(sortedValues, 0.25),
    median: quantileSorted(sortedValues, 0.5),
    q3: quantileSorted(sortedValues, 0.75),
    max: sortedValues[sortedValues.length - 1],
  };
};
